import { ReactNode, ReactElement } from 'react';
import { useNavigate } from 'react-router';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { CacheService } from 'services';

// Configuration
import Configuration from 'core/configuration';
import { getSite } from 'utils/site';
import { RollupOrganizationEnums } from 'core/models';

// Types
interface IProps {
  children: ReactNode;
}

export const Auth0ProviderWithHistory = ({ children }: IProps): ReactElement => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState: AppState) => {
    const redirectToUri = CacheService.get(appState?.returnTo);
    // After getting the redirect uri, clear out the cached value
    CacheService.remove(appState?.returnTo);
    navigate(redirectToUri || window.location.pathname);
  };

  const site = getSite();
  const clientId =
    site === RollupOrganizationEnums.NARS ? Configuration.narsAuthClientId : Configuration.parsAuthClientId;
  if (!clientId) {
    console.log(`No client id found for site ${site}. Make sure environment variables are configured correctly.`);
  }

  return (
    <Auth0Provider
      clientId={clientId}
      domain={Configuration.authDomain}
      onRedirectCallback={onRedirectCallback}
      authorizationParams={{
        redirect_uri: Configuration.authRedirectUri,
        audience: Configuration.authAudience,
        scope: Configuration.authScope,
      }}
    >
      {children}
    </Auth0Provider>
  );
};
